function pad_left(num, size) {
  return ("000000000" + num).substr(-size);
}
function formatDate(this_date) {
  let date = new Date(this_date);

  let monthNames = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  let year = date.getFullYear();
  let monthIndex = date.getMonth();
  let day = pad_left(date.getDate(), 2);
  let hour = pad_left(date.getHours(), 2);
  let mins = pad_left(date.getMinutes(), 2);
  let secs = pad_left(date.getSeconds(), 2);
  // return year + "." + monthNames[monthIndex] + "." + day + " " + hour + ":" + mins;
  return (
    day + "/" + monthNames[monthIndex] + "/" + year + " " + hour + ":" + mins
  );
}

export default formatDate;
